import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVenmo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconVenmo"><Path d="M19.7658 2.5C20.4442 3.61062 20.75 4.75456 20.75 6.19959C20.75 10.8085 16.7807 16.7958 13.5592 21H6.20104L3.25 3.5091L9.69288 2.90278L11.2531 15.3487C12.711 12.9945 14.51 9.29493 14.51 6.77259C14.51 5.39196 14.2714 4.45157 13.8985 3.67726L19.7658 2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVenmo;
